import {
	SET_FORM_STATE,
	RESET_FIELDS,
	// Map
	GET_FAILURES_FILTERS,
	GET_FAILURES_VOICE,
	GET_FAILURES_PACKET,
	GET_DRIVETESTS_CITIES,
	GET_DRIVETESTS_DRIVES,
	GET_DRIVETESTS_DATES,
	GET_DRIVETESTS_LOGS,
	SET_SELECTED_DATES,
	SET_SELECTED_LOGS,
	GET_DRIVETEST,
	GET_DRIVETESTS_TECH_BAND,
	GET_UE_ROUTE,
	// Scanner
	GET_DRIVETEST_SCANNER_FREQUENCIES_2G,
	GET_DRIVETEST_SCANNER_FREQUENCIES_3G,
	GET_DRIVETEST_SCANNER_FREQUENCIES_4G,
	GET_DRIVETEST_SCANNER_FREQUENCIES_5G,
	GET_DRIVETEST_SCANNER_CODES_2G,
	GET_DRIVETEST_SCANNER_CODES_3G,
	GET_DRIVETEST_SCANNER_CODES_4G,
	GET_DRIVETEST_SCANNER_CODES_5G,
	GET_DRIVETEST_SCANNER,
	GET_SCANNER_ROUTE,
	GET_CROWDSOURCING,
	GET_TOPOLOGY_2G,
	GET_TOPOLOGY_3G,
	GET_TOPOLOGY_4G,
	GET_TOPOLOGY_5G,
	GET_CUSTOM_LAYER,
	// Map Compare
	GET_FAILURES_FILTERS_COMPARE,
	GET_FAILURES_VOICE_COMPARE,
	GET_FAILURES_PACKET_COMPARE,
	GET_DRIVETESTS_CITIES_COMPARE,
	GET_DRIVETESTS_DRIVES_COMPARE,
	GET_DRIVETESTS_DATES_COMPARE,
	SET_SELECTED_DATES_COMPARE,
	GET_DRIVETEST_COMPARE,
	GET_DRIVETEST_SCANNER_FREQUENCIES_2G_COMPARE,
	GET_DRIVETEST_SCANNER_FREQUENCIES_3G_COMPARE,
	GET_DRIVETEST_SCANNER_FREQUENCIES_4G_COMPARE,
	GET_DRIVETEST_SCANNER_FREQUENCIES_5G_COMPARE,
	GET_DRIVETEST_SCANNER_CODES_2G_COMPARE,
	GET_DRIVETEST_SCANNER_CODES_3G_COMPARE,
	GET_DRIVETEST_SCANNER_CODES_4G_COMPARE,
	GET_DRIVETEST_SCANNER_CODES_5G_COMPARE,
	GET_DRIVETEST_SCANNER_COMPARE,
	GET_SCANNER_ROUTE_COMPARE,
	GET_CROWDSOURCING_COMPARE,
	GET_TOPOLOGY_2G_COMPARE,
	GET_TOPOLOGY_3G_COMPARE,
	GET_TOPOLOGY_4G_COMPARE,
	GET_TOPOLOGY_5G_COMPARE,
	// Global
	TOGGLE_FILTERS,
	CLEAR_FORM,
	TOGGLE_CARRIERS_COLORS_DIALOG,
	TOGGLE_CUSTOM_LAYER_DIALOG,
	GET_CARRIERS_COLORS,
	GET_SITES_IDS,
	GET_SITE_ID_LOCATION,
	TOGGLE_CARRIERS_COLORS_PICKER_DIALOG,
	TOGGLE_XCAP_TOOL_DIALOG
} from '../actions/DualMapActions';

const initialState = {
	// Map
	failuresFilters: [],
	failuresVoice: [],
	failuresPacket: [],
	cities: [],
	drives: [],
	dates: [],
	selectedDates: [],
	selectedLogs: [],
	driveTest: [],
	driveTestScannerFrequencies2g: [],
	driveTestScannerFrequencies3g: [],
	driveTestScannerFrequencies4g: [],
	driveTestScannerFrequencies5g: [],
	driveTestScannerCodes2g: [],
	driveTestScannerCodes3g: [],
	driveTestScannerCodes4g: [],
	driveTestScannerCodes5g: [],
	driveTestScanner: [],
	crowdsourcing: [],
	topology2gData: [],
	topology3gData: [],
	topology4gData: [],
	topology5gData: [],
	topologyLabelsData: [],
	techBand: [],
	customLayer: '',
	// Map Compare
	failuresFiltersCompare: [],
	failuresVoiceCompare: [],
	failuresPacketCompare: [],
	drivesCompare: [],
	datesCompare: [],
	selectedDatesCompare: [],
	driveTestCompare: [],
	driveTestScannerFrequencies2gCompare: [],
	driveTestScannerFrequencies3gCompare: [],
	driveTestScannerFrequencies4gCompare: [],
	driveTestScannerFrequencies5gCompare: [],
	driveTestScannerCodes2gCompare: [],
	driveTestScannerCodes3gCompare: [],
	driveTestScannerCodes4gCompare: [],
	driveTestScannerCodes5gCompare: [],
	driveTestScannerCompare: [],
	crowdsourcingCompare: [],
	topology2gDataCompare: [],
	topology3gDataCompare: [],
	topology4gDataCompare: [],
	topology5gDataCompare: [],
	topologyLabelsDataCompare: [],
	techBandVoiceCompare: [],
	techBandPacketCompare: [],
	// Global
	kpiFilesTree: [],
	openFilters: false,
	carriersColorsDialogVisibility: false,
	customLayerDialogVisibility: false,
	carriersColorsPickerDialogVisibility: false,
	xcapToolDialogVisibility: false,
	sitesIds: [],
	siteIdLocation: [],
	carriersColors: [],
	currentColorCode: 'white',
	formState: {
		isValid: false,
		values: {
			// Common
			mapAutoZoom: true,
			mapCompare: false,
			mapFrameSize: '80vw',
			mapSync: true,
			mapFilters: true,
			mapSize: 10,
			selectedCity: '',
			// Map
			selectedDrive: '',
			voiceActive: false,
			packetActive: false,
			failureTypeVoice: 'all',
			failureTypePacket: 'all',
			cfn1LevelVoice: 'all',
			cfn1LevelPacket: 'all',
			// scannerBsic: 'all',
			// scannerSc: 'all',
			// scannerPci: 'all',
			freq2g: '',
			freq3g: '',
			freq4g: '',
			freq5g: '',
			top2g: '',
			top3g: '',
			top4g: '',
			top5g: '',
			// Map Compare
			selectedCityCompare: '',
			selectedDriveCompare: '',
			voiceActiveCompare: false,
			packetActiveCompare: false,
			techBandVoiceActiveCompare: false,
			techBandPacketActiveCompare: false,
			failureTypeVoiceCompare: 'all',
			failureTypePacketCompare: 'all',
			cfn1LevelVoiceCompare: 'all',
			cfn1LevelPacketCompare: 'all',
			// scannerBsicCompare: 'all',
			// scannerScCompare: 'all',
			// scannerPciCompare: 'all',
			freq2gCompare: '',
			freq3gCompare: '',
			freq4gCompare: '',
			freq5gCompare: '',
			top2gCompare: '',
			top3gCompare: '',
			top4gCompare: '',
			top5gCompare: ''
		},
		touched: {},
		errors: {},
	},
};

const dualMapReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							// drives: [],
							// dates: [],
							formState: initialState.formState
						};
					}
					// Map
					case GET_FAILURES_FILTERS: {
						return {
							...state,
							failuresFilters: action.failuresFilters,
							formState: initialState.formState
						};
					}
					case GET_FAILURES_VOICE: {
						return {
							...state,
							failuresVoice: action.failuresVoice
						};
					}
					case GET_FAILURES_PACKET: {
						return {
							...state,
							failuresPacket: action.failuresPacket
						};
					}
					case GET_DRIVETESTS_CITIES: {
						return {
							...state,
							cities: action.cities
						};
					}
					case GET_DRIVETESTS_DRIVES: {
						return {
							...state,
							drives: action.drives
						};
					}
					case GET_DRIVETESTS_DATES: {
						return {
							...state,
							dates: action.dates
						};
					}
					case GET_DRIVETESTS_LOGS: {
						return {
							...state,
							logs: action.logs
						};
					}
					case SET_SELECTED_DATES: {
						return {
							...state,
							selectedDates: action.selectedDates
						};
					}
					case SET_SELECTED_LOGS: {
						return {
							...state,
							selectedLogs: action.selectedLogs
						};
					}
					case GET_DRIVETEST: {
						return {
							...state,
							driveTest: action.driveTest
						};
					}
					case GET_DRIVETESTS_TECH_BAND: {
						return {
							...state,
							techBand: action.techBand
						};
					}
					case GET_UE_ROUTE: {
						return {
							...state,
							ueRoute: action.ueRoute
						};
					}
					// Scanner
					case GET_DRIVETEST_SCANNER_FREQUENCIES_2G: {
						return {
							...state,
							driveTestScannerFrequencies2g: action.driveTestScannerFrequencies2g
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_3G: {
						return {
							...state,
							driveTestScannerFrequencies3g: action.driveTestScannerFrequencies3g
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_4G: {
						return {
							...state,
							driveTestScannerFrequencies4g: action.driveTestScannerFrequencies4g
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_5G: {
						return {
							...state,
							driveTestScannerFrequencies5g: action.driveTestScannerFrequencies5g
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_2G: {
						return {
							...state,
							driveTestScannerCodes2g: action.driveTestScannerCodes2g
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_3G: {
						return {
							...state,
							driveTestScannerCodes3g: action.driveTestScannerCodes3g
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_4G: {
						return {
							...state,
							driveTestScannerCodes4g: action.driveTestScannerCodes4g
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_5G: {
						return {
							...state,
							driveTestScannerCodes5g: action.driveTestScannerCodes5g
						};
					}
					case GET_DRIVETEST_SCANNER: {
						return {
							...state,
							driveTestScanner: action.driveTestScanner
						};
					}
					case GET_SCANNER_ROUTE: {
						return {
							...state,
							scannerRoute: action.scannerRoute
						};
					}
					case GET_CROWDSOURCING: {
						return {
							...state,
							crowdsourcing: action.crowdsourcing
						};
					}
					case GET_TOPOLOGY_2G: {
						return {
							...state,
							topology2gData: action.topology2gData,
							topologyLabelsData: action.topology2gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_3G: {
						return {
							...state,
							topology3gData: action.topology3gData,
							topologyLabelsData: action.topology3gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_4G: {
						return {
							...state,
							topology4gData: action.topology4gData,
							topologyLabelsData: action.topology4gData.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_5G: {
						return {
							...state,
							topology5gData: action.topology5gData,
							topologyLabelsData: action.topology5gData.topologyLabelsDto
						};
					}
					case GET_CUSTOM_LAYER: {
						return {
							...state,
							customLayer: action.customLayer,
						};
					}
					// Map Compare
					case GET_FAILURES_FILTERS_COMPARE: {
						return {
							...state,
							failuresFiltersCompare: action.failuresFiltersCompare,
							formState: initialState.formState
						};
					}
					case GET_FAILURES_VOICE_COMPARE: {
						return {
							...state,
							failuresVoiceCompare: action.failuresVoiceCompare
						};
					}
					case GET_FAILURES_PACKET_COMPARE: {
						return {
							...state,
							failuresPacketCompare: action.failuresPacketCompare
						};
					}
					case GET_DRIVETESTS_CITIES_COMPARE: {
						return {
							...state,
							citiesCompare: action.citiesCompare
						};
					}
					case GET_DRIVETESTS_DRIVES_COMPARE: {
						return {
							...state,
							drivesCompare: action.drivesCompare
						};
					}
					case GET_DRIVETESTS_DATES_COMPARE: {
						return {
							...state,
							datesCompare: action.datesCompare
						};
					}
					case SET_SELECTED_DATES_COMPARE: {
						return {
							...state,
							selectedDatesCompare: action.selectedDatesCompare
						};
					}
					case GET_DRIVETEST_COMPARE: {
						return {
							...state,
							driveTestCompare: action.driveTestCompare
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_2G_COMPARE: {
						return {
							...state,
							driveTestScannerFrequencies2gCompare: action.driveTestScannerFrequencies2gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_3G_COMPARE: {
						return {
							...state,
							driveTestScannerFrequencies3gCompare: action.driveTestScannerFrequencies3gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_4G_COMPARE: {
						return {
							...state,
							driveTestScannerFrequencies4gCompare: action.driveTestScannerFrequencies4gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_FREQUENCIES_5G_COMPARE: {
						return {
							...state,
							driveTestScannerFrequencies5gCompare: action.driveTestScannerFrequencies5gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_2G_COMPARE: {
						return {
							...state,
							driveTestScannerCodes2gCompare: action.driveTestScannerCodes2gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_3G_COMPARE: {
						return {
							...state,
							driveTestScannerCodes3gCompare: action.driveTestScannerCodes3gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_4G_COMPARE: {
						return {
							...state,
							driveTestScannerCodes4gCompare: action.driveTestScannerCodes4gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_CODES_5G_COMPARE: {
						return {
							...state,
							driveTestScannerCodes5gCompare: action.driveTestScannerCodes5gCompare
						};
					}
					case GET_DRIVETEST_SCANNER_COMPARE: {
						return {
							...state,
							driveTestScannerCompare: action.driveTestScannerCompare
						};
					}
					case GET_SCANNER_ROUTE_COMPARE: {
						return {
							...state,
							scannerRouteCompare: action.scannerRouteCompare
						};
					}
					case GET_CROWDSOURCING_COMPARE: {
						return {
							...state,
							crowdsourcingCompare: action.crowdsourcingCompare
						};
					}
					case GET_TOPOLOGY_2G_COMPARE: {
						return {
							...state,
							topology2gDataCompare: action.topology2gDataCompare,
							topologyLabelsDataCompare: action.topology2gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_3G_COMPARE: {
						return {
							...state,
							topology3gDataCompare: action.topology3gDataCompare,
							topologyLabelsDataCompare: action.topology3gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_4G_COMPARE: {
						return {
							...state,
							topology4gDataCompare: action.topology4gDataCompare,
							topologyLabelsDataCompare: action.topology4gDataCompare.topologyLabelsDto
						};
					}
					case GET_TOPOLOGY_5G_COMPARE: {
						return {
							...state,
							topology5gDataCompare: action.topology5gDataCompare,
							topologyLabelsDataCompare: action.topology5gDataCompare.topologyLabelsDto
						};
					}
					// Global
					case TOGGLE_FILTERS: {
						return {
							...state,
							openFilters: action.openFilters
						};
					}
					case CLEAR_FORM: {
						return {
							...state,
							formState: initialState.formState
						};
					}
					case GET_SITES_IDS: {
						return {
							...state,
							sitesIds: action.sitesIds
						};
					}
					case GET_SITE_ID_LOCATION: {
						return {
							...state,
							siteIdLocation: action.siteIdLocation
						};
					}
					case TOGGLE_CARRIERS_COLORS_DIALOG: {
						return {
							...state,
							carriersColorsDialogVisibility: action.visible
						};
					}
					case TOGGLE_CUSTOM_LAYER_DIALOG: {
						return {
							...state,
							customLayerDialogVisibility: action.visible
						};
					}
					case TOGGLE_CARRIERS_COLORS_PICKER_DIALOG: {
						return {
							...state,
							carriersColorsPickerDialogVisibility: action.visible,
							tableIdColorCode: action.tableIdColorCode,
							currentColorCode: action.currentColorCode
						};
					}
					case GET_CARRIERS_COLORS: {
						return {
							...state,
							carriersColors: action.carriersColors
						};
					}
					case TOGGLE_XCAP_TOOL_DIALOG: {
						return {
							...state,
							xcapToolDialogVisibility: action.visible
						};
					}
					default: {
						return state;
					}
	}
};

export default dualMapReducer;
